<template lang="pug">
section.gallery__section
  headroom#gallery__header--container.fixed--up
    .gallery__section--header
      .toggle
        .bars(
          @click='gridView = false',
          :class='{active: !gridView}')
          .bar
          .bar

        .grid(
          @click='gridView = true',
          :class='{active: gridView}')
          .square
          .square
          .square
          .square
      .sectionTitle.sectionTitle--mobile
        .mobileCategory(@click='toggleMobileGallery()')
          h1 {{ gallery }}
          i.fa.fa-chevron-down
        ul.gallery__menu(v-if='mobileGalleryShow')
          h1 Galleries
          a.close(@click='toggleMobileGallery()')
          li(
            v-for='category in galleryList.categories',
            :class='{active: galleryList.active === category.slug}')

              router-link.hide-desktop(
                @click.native='toggleMobileGallery()',
                :to="/cinemagraphs/ + category.slug" ) {{ category.name }}

      .sectionTitle.sectionTitle--desktop
        h1 {{ gallery }}
      .filter(@mouseover='filterHoverOn' @mouseleave='filterHoverOff')
        .btn.btn--black#filterBtn Categories
          i.fa.fa-chevron-down#chevron
          .filter__container#gallery
            ul
              li(
                v-for='category in galleryList.categories',
                :class='{active: galleryList.active === category.slug}')

                  router-link.hide-mobile(:to="/cinemagraphs/ + category.slug" ) {{ category.name }}
  flixel-list.fadeIn(
    :flixels='flixels',
    :grid-view='gridView')

  slide-show.black.showcase-modal(
    v-if="slideshow.show",
    :collection='flixels',
    :index='slideshow.index')
</template>

<script>
import { headroom } from 'vue-headroom';
import FlixelService from 'services/flixel.es6.js';
import FlixelList from 'components/FlixelList.vue';
import GalleryList from 'services/galleryList.es6.js';
import seoService from 'services/seo.es6.js';
import Scroll from 'directives/Scroll.js';
import Slideshow from 'components/Slideshow.vue';
import EventBus from '../eventBus.js';

export default {
  name: 'Gallery',
  props: ['gallery_name'],
  metaInfo() {
    return {
      title: this.capitalize(this.gallery_name) + ' Cinemagraphs | Flixel Living Photos',
      meta: [
        {
          'property': 'image',
          'content': this.metaInfo.image,
        },
        {
          'property': 'description',
          'content': this.metaInfo.description,
        },
      ],
    };
  },
  data() {
    return {
      gridView: false,
      mobileGalleryShow: false,
      slideshow: {
        show: false,
        flixel: '',
        index: '',
      },
      isLoading: false,
      flixels: '',
      menuToggle: true,
      isMobile: false,
      galleryList: {
        categories: GalleryList(),
        show: !this.isMobile,
      },
      chevron: document.getElementById('chevron'),
      gallery: this.gallery_name,
      lastScrollTop: 0,
      delta: 0,
      scrollPos: 0,
      metaInfo: {
        image: '',
        description: '',
      },
    };
  },
  created() {
    EventBus.$on('openslideshow', (flixel, index) => {
      this.slideshow.flixel = flixel;
      this.slideshow.index = index;
      this.slideshow.show = true;
      $('body').addClass('disable-scrolling');
    });
    EventBus.$on('closeslideshow', () => {
      this.slideshow.show = false;
      $('body').removeClass('disable-scrolling');
    });
  },
  mounted() {
    this.loadFlixelsInvoke(this.gallery);
    this.loadMetaInfo();
  },
  directives: {
    scroll: Scroll,
  },
  watch: {
    '$route'(to, from) {
      this.loadFlixelsInvoke(this.gallery_name);
      this.loadMetaInfo();
    },
  },
  methods: {
    loadFlixelsInvoke(name) {
      this.isLoading = true;
      const options = this.getOptions(name);
      FlixelService.getList(options)
        .then(this.loadFlixelsSuccess, this.loadFlixelsError);
    },
    loadFlixelsSuccess(data) {
      this.gallery = this.gallery_name;
      this.flixels = data;
    },
    loadFlixelsError(error) {
      console.log(error);
    },
    getOptions(name) {
      return {
        cache: true,
        params: {
          gallery_name: name,
          page_size: 50,
        },
      };
    },
    toggleMobileGallery() {
      this.mobileGalleryShow = !this.mobileGalleryShow;
      if (this.mobileGalleryShow === true) {
        this.scrollPos = $('body').scrollTop();
        $('#gallery__header--container').css({
          zIndex: 2002,
          transition: 'all 0s linear',
          transform: 'translateY(0%)',
        });
        $('body').css({
          overflow: 'hidden',
          position: 'fixed',
          top: -this.scrollPos,
        });
      } else {
        $('#gallery__header--container').css({
          zIndex: '1000',
          transition: '',
          transform: '',
        });
        $('body').css({
          overflow: '',
          position: '',
          top: '',
        }).scrollTop(this.scrollPos);
        $(this.galleryHeaderContainer).removeClass('mobileGallery');
      }
    },
    filterBtn() {
      if (menuToggle) {
        this.gallery.style.visibility = 'visible';
        this.gallery.style.opacity = '1';
        this.gallery.style.paddingTop = '10px';
        this.chevron.style.transform = 'rotate(180deg)';
        this.menuToggle = false;
      } else {
        this.gallery.style.visibility = 'hidden';
        this.gallery.style.opacity = '0';
        this.gallery.style.paddingTop = '0';
        this.chevron.style.transform = 'rotate(0deg)';
        this.menuToggle = true;
      }
    },
    filterHoverOn() {
      gallery.style.visibility = 'visible';
      gallery.style.opacity = '1';
      gallery.style.paddingTop = '10px';
      chevron.style.transform = 'rotate(180deg)';
    },
    filterHoverOff() {
      gallery.style.visibility = 'hidden';
      gallery.style.opacity = '0';
      gallery.style.paddingTop = '0';
      chevron.style.transform = 'rotate(0deg)';
    },
    loadMetaInfo() {
      const self = this;
      for (const i in GalleryList()) {
        if (self.galleryList.categories[i].name === self.gallery_name) {
          this.metaInfo.image = this.galleryList.categories[i].image;
          this.metaInfo.description = this.galleryList.categories[i].desc;
        }
      }
    },
    capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
  },
  components: {
    'flixel-list': FlixelList,
    'slide-show': Slideshow,
    'headroom': headroom,
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Gallery.vue